export default __webpack_public_path__ + "static/media/archived.0e71c1bf.svg";